<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu border-0 shadow-sm" id="sidemenu">
  <!-- LOGO -->
  <div class="navbar-brand-box position-relative">
    <!-- Dark Logo-->
    <a routerLink="{{'/'+ routeName  + '/dashboard'}}" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/neXtere-sort.png" alt="" height="22" class="w-100">
      </span>
      <span class="logo-lg justify-content-center">
        <img src="assets/images/neXtere.png" alt="" height="35" class="w-100">
      </span>
    </a>
    <!-- Light Logo-->
    <a routerLink="{{'/'+ routeName  + '/dashboard'}}" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/neXtere-sort.png" alt="" height="22" class="w-100">
      </span>
      <span class="logo-lg justify-content-center">
        <img src="assets/images/neXtere.png" alt="" height="35" class="w-100">
      </span>
    </a>
  </div>

  <div id="scrollbar">
    <div class="container-fluid">

      <div id="two-column-menu">
      </div>
      <ngx-simplebar class="sidebar-menu-scroll" style="max-height: calc(100vh - 70px)">
        <ul class="metismenu list-unstyled navbar-nav" id="navbar-nav">
          @for(item of menus; track $index){
            @if(item.isTitle){
            <li class="menu-title "><span data-key="t-menu">{{ item.label }}</span></li>
            }@else {
            <li class="nav-item" kendoTooltip position="right"
              tooltipClass="{{isDefaultSideBar ? 'my-class' : 'my-class-1'}}">
              @if(hasItems(item)){
              <a class="is-parent nav-link menu-link" title="{{item.label}}"
                [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}" data-bs-toggle="collapse"
                [attr.aria-expanded]="!item.isCollapsed" (click)="toggleItem(item)">
                <i class="{{ item.icon }} icon nav-icon" class=""></i>
                <span class="ms-2"> {{ item.label }}</span>
              </a>

              <div class="collapse menu-dropdown" #collapse="ngbCollapse" [(ngbCollapse)]="item.isCollapsed">
                <ul class="nav nav-sm flex-column">
                  @for(subitem of item.subItems; track $index){
                  <li class="nav-item">
                    @if(hasItems(subitem)){
                    <a class="nav-link" [attr.data-parent]="subitem.parentId" data-bs-toggle="collapse"
                      [attr.aria-expanded]="!subitem.isCollapsed" (click)="toggleItem(subitem)">
                      {{ subitem.label }}
                    </a>
                    <div class="collapse menu-dropdown sub-menu" #collapse="ngbCollapse"
                      [(ngbCollapse)]="subitem.isCollapsed">
                      <ul class="nav nav-sm flex-column">
                        @for(subSubitem of subitem.subItems; track $index){
                        <li class="nav-item">
                          @if(hasItems(subSubitem)){
                          <a class="nav-link " [attr.data-parent]="subSubitem.parentId" data-bs-toggle="collapse"
                            [attr.aria-expanded]="!subSubitem.isCollapsed" (click)="toggleItem(subSubitem)">
                            {{ subSubitem.label}}
                          </a>

                          <div class="collapse menu-dropdown extra-sub-menu" #collapse="ngbCollapse"
                            [(ngbCollapse)]="subSubitem.isCollapsed">
                            <ul class="nav nav-sm flex-column">
                              @for(subSubitem1 of subSubitem.subItems; track $index){
                              <li class="nav-item">
                                <a routerLink="{{'/'+ routeName +subSubitem1.link}}" class="nav-link "
                                  routerLinkActive="active" [attr.data-parent]="subSubitem1.parentId"
                                  (click)="updateActive($event)">
                                  {{ subSubitem1.label }}</a>

                              </li>
                              }
                            </ul>
                          </div>
                          }@else {
                          <a routerLink="{{'/'+ routeName +subSubitem.link}}" class="nav-link "
                            routerLinkActive="active" [attr.data-parent]="subSubitem.parentId"
                            (click)="updateActive($event)">
                            {{ subSubitem.label }}</a>
                          }
                        </li>
                        }
                      </ul>
                    </div>
                    }@else {
                    <a routerLink="{{'/'+ routeName +subitem.link}}" routerLinkActive="active" class=" nav-link "
                      [attr.data-parent]=" subitem.parentId" (click)="updateActive($event)">
                      {{ subitem.label }}
                    </a>
                    }
                  </li>
                  }
                </ul>
              </div>
              }@else {
              <a routerLink="{{'/'+ routeName  + item.link}}" title="{{item.label}}" routerLinkActive="active"
                class="side-nav-link-ref nav-link menu-link">
                @if(item.icon){<i class="bx {{ item.icon }} icon nav-icon" class=""></i>}
                <span class="ms-2"> {{ item.label }} </span>
                @if(item.badge){<span class="badge {{item.badge.variant}} float-end">{{item.badge.text }}</span>}
              </a>
              }
            </li>
            }
          }
        </ul>
      </ngx-simplebar>

    </div>
    <!-- Sidebar -->
  </div>
  <div class="sidebar-background"></div>
</div>
<!-- Left Sidebar End -->

<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="SidebarHide()" (keydown.enter)="SidebarHide()"></div>